import ResizeObserver from 'resize-observer-polyfill'
import { debounce, isFunction } from '@/utils'
const resize = {
  /**
   * binding.value
   * function || options({handler})
   * options
   * immediate: {
   * 	type: Boolean,
   * 	default: false
   * }  立即执行
   * handler:Function  处理函数 *** 必须
   * mode: {
   * 	type: String,
   * 	default: 'all'
   * }  'all' 'width' 'height'   // all-宽高   width-只检测宽   height-只检测高
   * other:   //其他附加信息
   */
  bind(el, binding) {
    if (!el) return
    let width = ''; let height = ''
    const handler = isFunction(binding.value) ? binding.value : binding.value.handler
    const immediate = isFunction(binding.value) ? false : (binding.value.immediate || false)
    const mode = isFunction(binding.value) ? 'all' : (binding.value.mode || 'all')
    const other = isFunction(binding.value) ? null : (binding.value.other || null)
    const modeObj = {
      all: style => width !== style.width || height !== style.height,
      width: style => width !== style.width,
      height: style => height !== style.height
    }
    const doResize = function () {
      const style = document.defaultView.getComputedStyle(el)
      if (modeObj[mode](style)) {
        handler({ width: parseFloat(style.width), height: parseFloat(style.height), other })
      }
      width = style.width
      height = style.height
    }
    const isResize = debounce(doResize, 200)
    if (immediate) setTimeout(doResize, 0)
    el.__vue_observer__ = new ResizeObserver(isResize)
    el.__vue_observer__.observe(el)
  },
  // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    if (!el) return
    el.__vue_observer__.disconnect()
  }
}

export default { resize }
